import { useForm } from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form/useForm";
import Form from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form";
import { useState } from "react";
import Joi from "joi-browser";
import { Button } from "V2.0/common/button";
import {
  Dialog,
  DialogBody,
  DialogTitle,
  DialogActions,
} from "V2.0/common/dialog";
import { message } from "antd";
import { addVoice } from "./service";
import { showErrorToast } from "V2.0/utils";

const template = [
  {
    name: "newName",
    label: "Name",
    description: "Set a custom name",
    type: "text",
  },
];

const schema = {
  //   publicOwnerId: Joi.string().required(),
  //   voiceId: Joi.string().required(),
  //   previewUrl: Joi.string().required(),
  newName: Joi.string().required().label("Name"),
  //   ttsServiceProvider: Joi.string().required(),
};

function VoiceAddForm(props) {
  const { voice, onCancel, fetchVoices } = props;
  const [inputField] = useState({
    newName: voice.name,
  });
  const { data, handleChange, error, setError, validate } = useForm(
    inputField,
    schema
  );
  const [loading, setLoading] = useState(false);

  async function handleSubmit() {
    const error = validate(data, schema);

    if (error) {
      setError(error);
      return;
    }

    const payload = {
      publicOwnerId: voice.public_owner_id,
      voiceId: voice.voice_id,
      previewUrl: voice.preview_url,
      ttsServiceProvider: "elevenlabs",
      name: voice.name,
      ...data,
    };
    message.loading("Adding Voice");
    try {
      setLoading(true);
      const response = await addVoice({ payload });
      if (response.status === 200) {
        fetchVoices();
        message.destroy();
        message.success("Voice added");
        setLoading(false);
        onCancel();
      }
    } catch (e) {
      message.destroy();
      showErrorToast(e, "Failed to add voice");
      setLoading(false);
    }
  }

  return (
    <Dialog open={true} onClose={onCancel}>
      <DialogTitle>Add Voice</DialogTitle>
      <DialogBody>
        <Form
          data={data}
          handleChange={handleChange}
          error={error}
          template={template}
        />
      </DialogBody>
      <DialogActions>
        <Button outline onClick={onCancel}>
          Cancel
        </Button>
        <Button loading={loading} onClick={handleSubmit}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export { VoiceAddForm };
